import React from "react";
import { StoreReducer } from "./StoreReducer";

const initVal = {
  error: false,
  message: "",
  success: false,
  isSave: false,
  isViewLedger: false,
  resultSet: [],
  isConfirm: false,
  isAdd: false,
  isAdd2: false,
  startIndex: 0,
  isSearch: false,
  status: false,
  isProgramChange: false,
  isCreatePass: false,
  credentials: {},
  isLogin: false,
  isAccountSame: false,
  searchUrl: "",
};

const StoreContext = React.createContext();

const StoreProvider = (props) => {
  const [store, dispatch] = React.useReducer(StoreReducer, initVal);

  return (
    <StoreContext.Provider value={{ store, dispatch }}>
      {props.children}
    </StoreContext.Provider>
  );
};

export { StoreContext, StoreProvider };
